const trigraphs = {
  AFG: 'AFGHANISTAN',
  XQZ: 'AKROTIRI',
  ALB: 'ALBANIA',
  DZA: 'ALGERIA',
  ASM: 'AMERICAN SAMOA',
  AND: 'ANDORRA',
  AGO: 'ANGOLA',
  AIA: 'ANGUILLA',
  ATA: 'ANTARCTICA',
  ATG: 'ANTIGUA AND BARBUDA',
  ARG: 'ARGENTINA',
  ARM: 'ARMENIA',
  ABW: 'ARUBA',
  XAC: 'ASHMORE AND CARTIER ISLANDS',
  AUS: 'AUSTRALIA',
  AUT: 'AUSTRIA',
  AZE: 'AZERBAIJAN',
  BHS: 'BAHAMAS, THE',
  BHR: 'BAHRAIN',
  XBK: 'BAKER ISLAND',
  BGD: 'BANGLADESH',
  BRB: 'BARBADOS',
  XBI: 'BASSAS DA INDIA',
  BLR: 'BELARUS',
  BEL: 'BELGIUM',
  BLZ: 'BELIZE',
  BEN: 'BENIN',
  BMU: 'BERMUDA',
  BTN: 'BHUTAN',
  BOL: 'BOLIVIA',
  BES: 'BONAIRE, SINT EUSTATIUS AND SABA',
  BIH: 'BOSNIA AND HERZEGOVINA',
  BWA: 'BOTSWANA',
  BVT: 'BOUVET ISLAND',
  BRA: 'BRAZIL',
  IOT: 'BRITISH INDIAN OCEAN TERRITORY',
  BRN: 'BRUNEI',
  BGR: 'BULGARIA',
  BFA: 'BURKINA FASO',
  MMR: 'BURMA',
  BDI: 'BURUNDI',
  CPV: 'CABO VERDE',
  KHM: 'CAMBODIA',
  CMR: 'CAMEROON',
  CAN: 'CANADA',
  CYM: 'CAYMAN ISLANDS',
  CAF: 'CENTRAL AFRICAN REPUBLIC',
  TCD: 'CHAD',
  CHL: 'CHILE',
  CHN: 'CHINA',
  CXR: 'CHRISTMAS ISLAND',
  CPT: 'CLIPPERTON ISLAND',
  CCK: 'COCOS (KEELING) ISLANDS',
  COL: 'COLOMBIA',
  COM: 'COMOROS',
  COG: 'CONGO (BRAZZAVILLE)',
  COD: 'CONGO(KINSHASA)',
  COK: 'COOK ISLANDS',
  XCS: 'CORAL SEA ISLANDS',
  CRI: 'COSTA RICA',
  CIV: `CÔTE D'IVOIRE`,
  HRV: 'CROATIA',
  CUB: 'CUBA',
  CUW: 'CURAÇAO',
  CYP: 'CYPRUS',
  CZE: 'CZECH REPUBLIC',
  DNK: 'DENMARK',
  XXD: 'DHEKELIA',
  DGA: 'DIEGO GARCIA',
  DJI: 'DJIBOUTI',
  DMA: 'DOMINICA',
  DOM: 'DOMINICAN REPUBLIC',
  ECU: 'ECUADOR',
  EGY: 'EGYPT',
  SLV: 'EL SALVADOR',
  XAZ: 'ENTITY 1',
  XCR: 'ENTITY 2',
  XCY: 'ENTITY 3',
  XKM: 'ENTITY 4',
  XKN: 'ENTITY 5',
  AX3: 'ENTITY 6',
  GNQ: 'EQUATORIAL GUINEA',
  ERI: 'ERITREA',
  EST: 'ESTONIA',
  ETH: 'ETHIOPIA',
  XEU: 'EUROPA ISLAND',
  FLK: 'FALKLAND ISLANDS (ISLAS MALVINAS)',
  FRO: 'FAROE ISLANDS',
  FJI: 'FIJI',
  FIN: 'FINLAND',
  FRA: 'FRANCE',
  GUF: 'FRENCH GUIANA',
  PYF: 'FRENCH POLYNESIA',
  ATF: 'FRENCH SOUTHERN AND ANTARCTIC LANDS',
  GAB: 'GABON',
  GMB: 'GAMBIA, THE',
  XGZ: 'GAZA STRIP',
  GEO: 'GEORGIA',
  DEU: 'GERMANY',
  GHA: 'GHANA',
  GIB: 'GIBRALTAR',
  XGL: 'GLORIOSO ISLANDS',
  GRC: 'GREECE',
  GRL: 'GREENLAND',
  GRD: 'GRENADA',
  GLP: 'GUADELOUPE',
  GUM: 'GUAM',
  AX2: 'GUANTANAMO BAY NAVAL BASE',
  GTM: 'GUATEMALA',
  GGY: 'GUERNSEY',
  GIN: 'GUINEA',
  GNB: 'GUINEA-BISSAU',
  GUY: 'GUYANA',
  HTI: 'HAITI',
  HMD: 'HEARD ISLAND AND MCDONALD ISLANDS',
  // VAT: 'HOLY SEE (VATICAN CITY STATE)',
  HND: 'HONDURAS',
  HKG: 'HONG KONG',
  XHO: 'HOWLAND ISLAND',
  HUN: 'HUNGARY',
  ISL: 'ICELAND',
  IND: 'INDIA',
  IDN: 'INDONESIA',
  IRN: 'IRAN',
  IRQ: 'IRAQ',
  IRL: 'IRELAND',
  IMN: 'ISLE OF MAN',
  ISR: 'ISRAEL',
  ITA: 'ITALY',
  JAM: 'JAMAICA',
  XJM: 'JAN MAYEN',
  JPN: 'JAPAN',
  XJV: 'JARVIS ISLAND',
  JEY: 'JERSEY',
  XJA: 'JOHNSTON ATOLL',
  JOR: 'JORDAN',
  XJN: 'JUAN DE NOVA ISLAND',
  KAZ: 'KAZAKHSTAN',
  KEN: 'KENYA',
  XKR: 'KINGMAN REEF',
  KIR: 'KIRIBATI',
  PRK: 'KOREA, NORTH',
  KOR: 'KOREA, SOUTH',
  XKS: 'KOSOVO',
  KWT: 'KUWAIT',
  KGZ: 'KYRGYZSTAN',
  LAO: 'LAOS',
  LVA: 'LATVIA',
  LBN: 'LEBANON',
  LSO: 'LESOTHO',
  LBR: 'LIBERIA',
  LBY: 'LIBYA',
  LIE: 'LIECHTENSTEIN',
  LTU: 'LITHUANIA',
  LUX: 'LUXEMBOURG',
  MAC: 'MACAU',
  MKD: 'MACEDONIA',
  MDG: 'MADAGASCAR',
  MWI: 'MALAWI',
  MYS: 'MALAYSIA',
  MDV: 'MALDIVES',
  MLI: 'MALI',
  MLT: 'MALTA',
  MHL: 'MARSHALL ISLANDS',
  MTQ: 'MARTINIQUE',
  MRT: 'MAURITANIA',
  MUS: 'MAURITIUS',
  MYT: 'MAYOTTE',
  MEX: 'MEXICO',
  FSM: 'MICRONESIA, FEDERATED STATES OF',
  XMW: 'MIDWAY ISLANDS',
  MDA: 'MOLDOVA',
  MCO: 'MONACO',
  MNG: 'MONGOLIA',
  MNE: 'MONTENEGRO',
  MSR: 'MONTSERRAT',
  MAR: 'MOROCCO',
  MOZ: 'MOZAMBIQUE',
  NAM: 'NAMIBIA',
  NRU: 'NAURU',
  XNV: 'NAVASSA ISLAND',
  NPL: 'NEPAL',
  NLD: 'NETHERLANDS',
  NCL: 'NEW CALEDONIA',
  NZL: 'NEW ZEALAND',
  NIC: 'NICARAGUA',
  NER: 'NIGER',
  NGA: 'NIGERIA',
  NIU: 'NIUE',
  NFK: 'NORFOLK ISLAND',
  MNP: 'NORTHERN MARIANA ISLANDS',
  NOR: 'NORWAY',
  OMN: 'OMAN',
  PAK: 'PAKISTAN',
  PLW: 'PALAU',
  XPL: 'PALMYRA ATOLL',
  PAN: 'PANAMA',
  PNG: 'PAPUA NEW GUINEA',
  XPR: 'PARACEL ISLANDS',
  PRY: 'PARAGUAY',
  PER: 'PERU',
  PHL: 'PHILIPPINES',
  PCN: 'PITCAIRN ISLANDS',
  POL: 'POLAND',
  PRT: 'PORTUGAL',
  PRI: 'PUERTO RICO',
  QAT: 'QATAR',
  REU: 'REUNION',
  ROU: 'ROMANIA',
  RUS: 'RUSSIA',
  RWA: 'RWANDA',
  BLM: 'SAINT BARTHELEMY',
  SHN: 'SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA',
  KNA: 'SAINT KITTS AND NEVIS',
  LCA: 'SAINT LUCIA',
  MAF: 'SAINT MARTIN',
  SPM: 'SAINT PIERRE AND MIQUELON',
  VCT: 'SAINT VINCENT AND THE GRENADINES',
  WSM: 'SAMOA',
  SMR: 'SAN MARINO',
  STP: 'SAO TOME AND PRINCIPE',
  SAU: 'SAUDI ARABIA',
  SEN: 'SENEGAL',
  SRB: 'SERBIA',
  SYC: 'SEYCHELLES',
  SLE: 'SIERRA LEONE',
  SGP: 'SINGAPORE',
  SXM: 'SINT MAARTEN',
  SVK: 'SLOVAKIA',
  SVN: 'SLOVENIA',
  SLB: 'SOLOMON ISLANDS',
  SOM: 'SOMALIA',
  ZAF: 'SOUTH AFRICA',
  SGS: 'SOUTH GEORGIA AND SOUTH SANDWICH ISLANDS',
  SSD: 'SOUTH SUDAN',
  ESP: 'SPAIN',
  XSP: 'SPRATLY ISLANDS',
  LKA: 'SRI LANKA',
  SDN: 'SUDAN',
  SUR: 'SURINAME',
  XSV: 'SVALBARD',
  SWZ: 'SWAZILAND',
  SWE: 'SWEDEN',
  CHE: 'SWITZERLAND',
  SYR: 'SYRIA',
  TWN: 'TAIWAN',
  TJK: 'TAJIKISTAN',
  TZA: 'TANZANIA',
  THA: 'THAILAND',
  TLS: 'TIMOR-LESTE',
  TGO: 'TOGO',
  TKL: 'TOKELAU',
  TON: 'TONGA',
  TTO: 'TRINIDAD AND TOBAGO',
  XTR: 'TROMELIN ISLAND',
  TUN: 'TUNISIA',
  TUR: 'TURKEY',
  TKM: 'TURKMENISTAN',
  TCA: 'TURKS AND CAICOS ISLANDS',
  TUV: 'TUVALU',
  UGA: 'UGANDA',
  UKR: 'UKRAINE',
  ARE: 'UNITED ARAB EMIRATES',
  GBR: 'UNITED KINGDOM',
  USA: 'UNITED STATES',
  AX1: 'UNKNOWN',
  URY: 'URUGUAY',
  UZB: 'UZBEKISTAN',
  VUT: 'VANUATU',
  VAT: 'VATICAN CITY',
  VEN: 'VENEZUELA',
  VNM: 'VIETNAM',
  VGB: 'VIRGIN ISLANDS, BRITISH',
  VIR: 'VIRGIN ISLANDS, U.S.',
  XWK: 'WAKE ISLAND',
  WLF: 'WALLIS AND FUTUNA',
  XWB: 'WEST BANK',
  ESH: 'WESTERN SAHARA',
  YEM: 'YEMEN',
  ZMB: 'ZAMBIA',
  ZWE: 'ZIMBABWE',
};

export default trigraphs;
